/**
 * Cleans itemDrafts payload by removing undefined/null/empty values
 * and ensuring cost_unit values are trimmed strings
 */
export function cleanItemDraftsPayload(
  itemDrafts: Record<string, string | undefined | null>
): Record<string, string> {
  const cleanedPayload: Record<string, string> = {}

  Object.entries(itemDrafts).forEach(([key, value]) => {
    // Only include defined, non-empty values
    if (value !== undefined && value !== null && value !== '') {
      // For cost_unit, ensure it's a valid string value
      if (key === 'cost_unit' && typeof value === 'string') {
        cleanedPayload[key] = value.trim()
      } else if (typeof value === 'string') {
        cleanedPayload[key] = value
      }
    }
  })

  return cleanedPayload
}
